import { combineReducers } from 'redux'
import dataReducer from './reducers/dataReducer.js'
import notificationReducer from './reducers/notificationReducer.js'
import firestoreSlice from './slices/firestoreSlice.js'
import profileSlice from './slices/profileSlice.js'


export default combineReducers({
  data: dataReducer,
  notifications: notificationReducer,
  profile: profileSlice,
  firestore: firestoreSlice,
})
